// Areas in the system benefit from a guid/uuid
// Although this is not a perfect primary key
// solution, the probability of a collide are 5.3x10^^-36
// Not to be used if a guaranteed unique ID is
// needed, but a useful helper if the minor
// probability would have little negative
// effect in event of collide

const crypto = window.crypto || window.msCrypto

export default () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}



// WEBPACK FOOTER //
// ./src/guid.js